const compare = require('./compare')
const compareLoose = (a, b) => compare(a, b, true)
module.exports = compareLoose



//////////////////
// WEBPACK FOOTER
// ./~/semver/functions/compare-loose.js
// module id = 2184
// module chunks = 0